import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withComponentId } from '../../common/ComponentIdContext';
import { REDUCER_NAME } from './reducer';
import Notifications from '../common/header/notifications';

class NotificationsWrapper extends React.Component {
  render() {
    const { companyScore } = this.props;
    return <Notifications data={companyScore} />;
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    locale: state.i18n.locale,
    companyScore: state[REDUCER_NAME].listMultiComponent[componentId].score,
    currentSearch:
      state[REDUCER_NAME].listMultiComponent[componentId].condition
        .currentSearch,
  };
};

export default compose(
  withComponentId,
  connect(mapStateToProps),
)(NotificationsWrapper);
